"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateIdServiceSelector = exports.AffiliateIdServiceSelectorTypeEnum = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
const affiliate_id_service_1 = require("./affiliate-id-service");
var AffiliateIdServiceSelectorTypeEnum;
(function (AffiliateIdServiceSelectorTypeEnum) {
    AffiliateIdServiceSelectorTypeEnum["NUM_JOBS_OVER_PERIOD"] = "Number of jobs over period";
})(AffiliateIdServiceSelectorTypeEnum = exports.AffiliateIdServiceSelectorTypeEnum || (exports.AffiliateIdServiceSelectorTypeEnum = {}));
let AffiliateIdServiceSelector = class AffiliateIdServiceSelector {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], AffiliateIdServiceSelector.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AffiliateIdServiceSelector.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(AffiliateIdServiceSelectorTypeEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: AffiliateIdServiceSelectorTypeEnum,
    }),
    __metadata("design:type", String)
], AffiliateIdServiceSelector.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'interval',
        nullable: true,
    }),
    __metadata("design:type", String)
], AffiliateIdServiceSelector.prototype, "period", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE, layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => affiliate_id_service_1.AffiliateIdService, (affiliateIdService) => affiliateIdService.selectorType),
    __metadata("design:type", Array)
], AffiliateIdServiceSelector.prototype, "services", void 0);
AffiliateIdServiceSelector = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Affiliate Id Service Selector',
        nameProperties: ['name'],
    }),
    (0, typeorm_1.Entity)('affiliate_id_service_selector', { schema: 'public' })
], AffiliateIdServiceSelector);
exports.AffiliateIdServiceSelector = AffiliateIdServiceSelector;
//# sourceMappingURL=affiliate-id-service-selector.js.map